import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import firebase from '../services/firebase';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Loader} from '../components/Loader';
import { Underline } from '../components/Underline';

const options = [
  { value: 'general', label: 'General' },
  { value: 'product', label: 'Product Related' },
  { value: 'order', label: 'Order Related' },
  { value: 'delivery', label: 'Delivery Related' },
];

export const Contact = () => {
  const user = useSelector((state) => state.user);
  const [name, setName] = useState(user.name || '');
  const [email, setEmail] = useState(user.email || '');
  const [phoneNumber, setPhoneNumber] = useState(user.phoneNumber || '');
  const [category, setCategory] = useState(null);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await firebase.submitContactForm({
        name,
        email,
        phoneNumber,
        category: category.value,
        message,
      });
      setName('');
      setEmail('');
      setPhoneNumber('');
      setCategory(null);
      setMessage('');
      setLoading(false);
      toast.success('Message sent successfully!', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
    } catch (error) {
      setLoading(false);
      toast.error('Error sending message: ' + error.message, {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
      console.error('Error sending message:', error);
    }
  };

  useEffect(() => {
    if (user.isAuthenticated) {
      setName(user.name);
      setEmail(user.email);
      setPhoneNumber(user.phoneNumber);
    }
  }, [user]);

  return (
    <div className="flex flex-col items-center justify-center h-full">
      <div className="bg-white p-[50px] py-[35px] rounded-lg shadow-md w-[400px] md:w-[500px]">
        <h2 className="text-2xl font-bold mb-4">Contact Us</h2>
        <Underline />

        {loading ? (
          <Loader />
        ) : (
          <form onSubmit={handleSubmit} className="w-full">
            <div className="mb-4">
              <label htmlFor="name" className="block font-medium mb-2">
                Name
              </label>
              <input
                type="text"
                id="name"
                className="px-3 w-full py-2 border border-gray-300 rounded-md focus:outline-none focus:border-primary"
                placeholder="Enter your name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <label htmlFor="email" className="block font-medium mb-2">
                Email
              </label>
              <input
                type="email"
                id="email"
                className="px-3 w-full py-2 border border-gray-300 rounded-md focus:outline-none focus:border-primary"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <label htmlFor="phoneNumber" className="block font-medium mb-2">
                Phone Number
              </label>
              <input
                type="tel"
                id="phoneNumber"
                className="px-3 w-full py-2 border border-gray-300 rounded-md focus:outline-none focus:border-primary"
                placeholder="Enter your phone number"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <label htmlFor="category" className="block font-medium mb-2">
                Category
              </label>
              <Select
                id="category"
                className="w-full"
                options={options}
                value={category}
                onChange={setCategory}
                placeholder="Select a category"
              />
            </div>
            <div className="mb-4">
              <label htmlFor="message" className="block font-medium mb-2">
                Message
              </label>
              <textarea
                id="message"
                className="px-3 w-full py-2 border border-gray-300 rounded-md focus:outline-none focus:border-primary"
                rows="4"
                placeholder="Enter your message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>
            </div>
            <button
              type="submit"
              className="bg-primary w-full mt-6 text-white font-medium py-2 px-4 rounded-md hover:bg-primaryDark"
            >
              Submit
            </button>
          </form>
        )}
      </div>
      <div className='w-full h-[50px]'></div>
      <ToastContainer />
    </div>
  );
};